import { makeAutoObservable } from 'mobx';
import { ExerciseTemplate, BundledExercise } from 'exercises/types';
import API from 'utils/API';
import exerciseData from 'exercises/exerciseData.json';

const CUSTOM_EXERCISES_LOCAL_STORAGE_KEY = 'CUSTOM_EXERCISES_LOCAL_STORAGE_KEY';

export class ExerciseTemplates {
  private _customExercises: ExerciseTemplate[] = [];
  private _bundledTemplates: BundledExercise[] = [];

  constructor() {
    makeAutoObservable(this);
    this._bundledTemplates = Object.values(exerciseData) as BundledExercise[];
  }

  get exercises(): ExerciseTemplate[] {
    const allExercises = [...this._customExercises, ...this._bundledTemplates];
    return allExercises
      .filter(e => e.is_archived === false)
      .sort(function (a, b) {
        const textA = a.title.toUpperCase();
        const textB = b.title.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
  }

  get bundledTemplates(): BundledExercise[] {
    return this._bundledTemplates;
  }

  getExercise(templateId: string): ExerciseTemplate | undefined {
    const maybeBundledExercise = this._bundledTemplates.find(e => e.id === templateId);

    return maybeBundledExercise
      ? maybeBundledExercise
      : this._customExercises.find(e => e.id === templateId);
  }

  hydrate = () => {
    const customExercisesJson = window.localStorage.getItem(CUSTOM_EXERCISES_LOCAL_STORAGE_KEY);
    if (customExercisesJson) {
      this._customExercises = JSON.parse(customExercisesJson);

      window.localStorage.setItem(
        CUSTOM_EXERCISES_LOCAL_STORAGE_KEY,
        JSON.stringify(this._customExercises),
      );
    }
  };

  clearData = () => {
    this._customExercises = [];
    window.localStorage.removeItem(CUSTOM_EXERCISES_LOCAL_STORAGE_KEY);
  };

  fetch = async () => {
    const result = await API.getCustomExerciseTemplates();
    this._customExercises = result.data;
    window.localStorage.setItem(
      CUSTOM_EXERCISES_LOCAL_STORAGE_KEY,
      JSON.stringify(this._customExercises),
    );
  };
}
